import {CommonMessages} from '../common.messages';

export const SearchClientMessages = {
    GetClientsFailed: {
        key: 'GetClientsFailed',
        message: 'Error while communication with the server. Cannot get information about clients.'
    },
    NoDataForSelectedRow: {
        key: 'NoDataForSelectedRow',
        message: 'No data found for selected row.'
    },
    ...CommonMessages
};
